import { BaseDto } from '../../core';
import { BuyerCompany } from './buyer-company.entity';
import { BUYER_STATUS } from '../../shared';
import { PointSetting } from '../wallet';

export class Buyer extends BaseDto<Buyer> {
  constructor(partial?: any) {
    super(partial);
  }

  id: number;
  email: string;
  firstName: string;
  lastName: string;
  callingCode: string;
  mobile: string;
  buyerCompanyId: number;
  buyerStatus: BUYER_STATUS;
  receiveInfoAgreed: boolean;
  receiveInfoAgreedUpdated: Date;
  buyerCompany: BuyerCompany;
  curMsiPrice: number;
  preMsiPrice: number;
  pointSettingId: number;
  pointSetting: PointSetting;
  nextMonthPointSetting: PointSetting;
  levelUpPointSetting: PointSetting;
  isFixedMoa: boolean;
  isNotFixedMoa: boolean;

  purchaseOrderCount: number;
}
